import { makeStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Typography, Button, Paper, CssBaseline } from '@material-ui/core'
import sliderImage_1 from '../../assets/images/sliderImage_1.png'
import sliderImage_2 from '../../assets/images/sliderImage_2.png'
import sliderImage_3 from '../../assets/images/sliderImage_3.png'

import Carousel from 'react-material-ui-carousel'

const useStyles = makeStyles((theme) => ({
  //TODO extract flex properties from slider classes
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(7),
    minHeight: '100vh',
  },
  imageContainer: {
    width: '70%',
  },
  img: {
    borderRadius: '50%',
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    height: '150px',
  },
  title: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
    fontSize: '1.5rem',
    lineHeight: '1.3',
    color: '#ffffff',
  },
  description: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
    fontSize: '1rem',
    lineHeight: '1.3',
    color: '#FFFFFF',
  },
  buttonsContainer: {
    width: '60%',
    marginTop: theme.spacing(2),
  },
  signinButton: {
    margin: theme.spacing(1, 0),
    border: '3px solid #FFFFFF',
    color: '#FFFFFF',
  },
  signupButton: {
    margin: theme.spacing(1.5, 0),
    color: '#FFFFFF',
    border: '3px solid #FFFFFF',
  },
}))

const useStylesMain = (props) =>
  makeStyles(() => ({
    container: {
      minHeight: '100vh',
      backgroundColor: props.backgroundColor,
    },
  }))

interface IItemProps {
  title: string
  description: string
  slider: number
  image: string
  backgroundColor: string
}

const CarrouselComponent = () => {
  const items: IItemProps[] = [
    {
      title: 'Invite your friends',
      description:
        'Ask friends to join a group of people where you will share moments, challenges, experiences and more.',
      slider: 1,
      image: sliderImage_1,
      backgroundColor: '#ff8b77',
    },
    {
      title: 'Start Dosing Up',
      description:
        'Create the experiences you want to share with your groups and encapsulate them in the form of doses.',
      slider: 2,
      image: sliderImage_2,
      backgroundColor: '#6d64e7',
    },
    {
      title: 'Discover the dose of the day!',
      description:
        "Check on Today's Dose and complete the experience selected, share your reactions and have fun!",
      slider: 3,
      image: sliderImage_3,
      backgroundColor: '#4acaa8',
    },
  ]
  const [activeSlide, setActiveSlide] = useState<IItemProps>(items[0])
  const classes = useStylesMain(activeSlide)()

  return (
    <Carousel
      next={(next) => setActiveSlide(items[next])}
      prev={(prev) => setActiveSlide(items[prev])}
      className={classes.container}
      swipe={true}
      cycleNavigation={false}
      autoPlay={false}
      navButtonsAlwaysVisible={true}
    >
      {items.map((item, i) => (
        <Item key={i} {...item} />
      ))}
    </Carousel>
  )
}

const Item = ({ title, description, image, backgroundColor }: IItemProps) => {
  const classes = useStyles()
  return (
    <Paper
      elevation={0}
      className={classes.mainContainer}
      style={{ backgroundColor: backgroundColor }}
    >
      <CssBaseline />
      <div className={classes.imageContainer}>
        <img src={image} className={classes.img} />
      </div>
      <Typography variant="h5" className={classes.title}>
        {title}
      </Typography>
      <Typography variant="body1" className={classes.description}>
        {description}
      </Typography>
      <div className={classes.buttonsContainer}>
        <Button
          className={classes.signinButton}
          fullWidth
          variant="outlined"
          component={Link}
          to="sign-in"
        >
          SIGN IN
        </Button>
        <Button
          className={classes.signupButton}
          fullWidth
          component={Link}
          variant="outlined"
          to="sign-up"
        >
          SIGN UP
        </Button>
      </div>
    </Paper>
  )
}

export const LandingPage = () => {
  return <CarrouselComponent />
}
